import {AssayResult} from 'results/assays/AssayRecordConstants';

export enum DataTableActionType {
  DATA_TABLES_VALIDATION_STATUS_FETCH_COMPLETED = 'DATA_TABLES_VALIDATION_STATUS_FETCH_COMPLETED',
}

interface DataTablesValidationStatusFetchedAction {
  type: DataTableActionType.DATA_TABLES_VALIDATION_STATUS_FETCH_COMPLETED;
  errorsByRecordId: {[recordId: string]: {[fieldId: string]: string}};
  assayResultsById: {[id: string]: AssayResult};
}

export function dataTablesValidationStatusFetchCompleted(
  errorsByRecordId: {[recordId: string]: {[fieldId: string]: string}},
  assayResultsById: {[id: string]: AssayResult}
): DataTablesValidationStatusFetchedAction {
  return {
    type: DataTableActionType.DATA_TABLES_VALIDATION_STATUS_FETCH_COMPLETED,
    errorsByRecordId,
    assayResultsById,
  };
}

export type DataTableAction = DataTablesValidationStatusFetchedAction;
